import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeLoaderService {
  DEFAULT_THEME = 'primary-theme';
  CUSTOM_THEMES = ['primary-theme', 'msm-theme'];

  init(theme: string) {
    const themeName = this.CUSTOM_THEMES.includes(theme)
      ? theme
      : this.DEFAULT_THEME;

    const head = document.getElementsByTagName('head')[0];

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${themeName}.css`;
    head.appendChild(link);
  }
}
